// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "style." + {"112":"5986fcf8bf4c68fa0f55","510":"239d6fdff0203bbb1de4","633":"9c524b5f7916666e6e9c"}[chunkId] + ".css";
};